export default __webpack_public_path__ + "static/media/blue-swoop.c7a41a14.png";